const Approvals = requireAuth => [
  {
    path: '/approvals/validate-request',
    name: 'ValidateRequest',
    component: () => import('./views/ValidateRequest'),
    beforeEnter: requireAuth
  },
  {
    path: '/approvals/validate-request-petty-cash',
    name: 'ValidateRequestPettyCash',
    component: () => import('../../container-components/validateRequestPettyCash.page'),
    beforeEnter: requireAuth
  }
]

export default Approvals



// WEBPACK FOOTER //
// ./src/modules/approvals/routes.js